export default __webpack_public_path__ + "static/media/dots_menu_filter.cffdf6e1.webp";